import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import SearchBar from '../SearchBar'
import Select from 'react-select'

const ResearchClientModal = (props) => {
  const {
    setClientId,
    clientId,
    setIsCreateViaModal,
    setIsClientSociety,
    choicedDemandeSource,
    setChoicedDemandeSource,
    sourceLoader,
    transformedSource,
    isEdit = false,
    setTempClientId,
    demandeId,
    setTempClient,
    refRechercheClient,
    isPrevious,
    searchTerm,
    setSearchTerm,
    demandeClient
  } = props
  const [close, setClose] = useState<boolean>(false)

  const equipe = demandeClient?.equipe?.nom;
  const equipeInitiale = demandeClient?.equipeInitial?.nom;

  // ne pas afficher l'ancienne liste des résultats à l'appuie du bouton close
  const handleClose = () => {
    setClose(true)
  }

  return (
    <div
      className='modal fade'
      id='exampleModalToggle'
      aria-hidden='true'
      aria-labelledby='exampleModalToggleLabel'
      tabIndex={-1}
    >
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title' id='exampleModalToggleLabel'>
              Choix d'un client
            </h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={handleClose}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body overflow-auto' style={{maxHeight: '67vh'}}>
            {/* changeClient > true , le site de l'équipe de la demande est différent du site du client */}
            {(demandeClient?.changeClient) && (
              <div className="mb-4" role="status">
                <div
                  className="d-flex align-items-start gap-3 rounded-3 border border-primary-subtle border-start border-4 border-start-primary bg-primary-subtle bg-opacity-25 px-3 py-3 mb-3"
                  role="note"
                >
                  <i className="bi bi-info-circle-fill text-primary fs-4 flex-shrink-0" aria-hidden="true"></i>

                  <div className="lh-sm">
                    <div className="fw-semibold text-body mb-1">
                      Choisir le bon client pour l'équipe{' '}
                      <span className="fw-bold text-primary-emphasis border-bottom border-2 border-primary">
                        {equipe}
                      </span>
                    </div>
                  </div>
                </div>

                {(equipeInitiale && equipeInitiale !== equipe) && (
                  <div className="rounded-3 border bg-body-tertiary p-3">
                    <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                      <span className="badge text-bg-light border text-body-secondary fw-medium text-decoration-line-through">
                        {equipeInitiale}
                      </span>
                      <i className="bi bi-arrow-right text-body-secondary" aria-hidden="true"></i>
                      <span className="badge text-bg-primary-subtle text-primary-emphasis border border-primary-subtle fw-semibold">
                        {equipe}
                      </span>
                      <span className="visually-hidden">
                        Passage de l'équipe {equipeInitiale} à l'équipe {equipe}
                      </span>
                    </div>

                    <div className="small text-body-secondary d-flex align-items-center gap-2">
                      <i className="bi bi-info-circle flex-shrink-0" aria-hidden="true"></i>
                      <span>Le client doit correspondre au nouveau site.</span>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* debut Affichage du demande source */}
            {!isEdit && (
              <div className='col-lg-12 col-sm-12 mb-3'>
                <label className='required mb-1' style={{fontSize: '1.17em'}} htmlFor='source'>
                  Canal de la demande
                </label>
                <Select
                  className='react-select-styled react-select-solid react-select-lg'
                  classNamePrefix='react-select'
                  options={transformedSource}
                  fieldName='motif_refus'
                  value={choicedDemandeSource?.label}
                  isLoading={sourceLoader}
                  onChange={(e) => setChoicedDemandeSource(e.value)}
                  placeholder='Sélectionner un canal '
                  // Ajout de z-index pour afficher le sélécteur sans overflow
                  menuPortalTarget={document.body}
                  menuPosition='fixed'
                  styles={{
                    menuPortal: (base) => ({...base, zIndex: 9999}),
                  }}
                />
                {!choicedDemandeSource && (
                  <div className='d-flex gap-2 my-2 align-items-center'>
                    <i className='bi bi-info-square text-warning'></i>
                    <span className={'text-warning'}>Veuillez choisir le canal de la demande</span>
                  </div>
                )}
              </div>
            )}
            {/* fin Affichage du demande source */}
            <SearchBar
              placeholder={'Rechercher un client'}
              setClientId={setClientId}
              clientId={clientId}
              setIsClientSociety={setIsClientSociety}
              close={close}
              setClose={setClose}
              choicedDemandeSource={choicedDemandeSource}
              setTempClientId={setTempClientId}
              setTempClient={setTempClient}
              refRechercheClient={refRechercheClient}
              isPrevious={isPrevious}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </div>
          <div className='modal-footer'>
            <div className='d-flex w-100 justify-content-between align-items-center'>
              <div className='text-gray-800 fw-bold fs-6'>
                Client non trouvé?{' '}
                <span
                  style={{color: '#9ac331', cursor: 'pointer'}}
                  data-bs-target='#ModalClientCreate'
                  data-bs-toggle='modal'
                  data-bs-dismiss='modal'
                  onClick={() => setIsCreateViaModal(true)}
                >
                  Créez-en un
                </span>
              </div>
              <div>
                {demandeId && (
                  <button
                    type='button'
                    className='btn btn-light me-3'
                    data-bs-dismiss='modal'
                    data-bs-target='#kt_modal_1'
                    data-bs-toggle='modal'
                  >
                    Retour
                  </button>
                )}
                <button
                  type='button'
                  className='btn btn-light'
                  data-bs-dismiss='modal'
                  onClick={() => handleClose()}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResearchClientModal
